// extracted by mini-css-extract-plugin
module.exports = {"showMore":"styles_showMore__1aSj6","total":"styles_total__22v0h"};